<template>
  <div style="display: none"></div>
</template>

<script>
import Cookies from "js-cookie";
import api from "@/api";
import { gioAdsTracking } from "@/utilities/tools";
export default {
  name: "EmergencyMessageAlert",
  mounted() {
    this.initPage();
  },
  methods: {
    initPage() {
      this.showMessage();
    },
    async showMessage() {
      const { success, data } = await api.page.getEmergencyMessage({
        terminal: "MOBILE"
      });
      if (success && data && data.description) {
        if(data.popupMessageType === '维护弹窗') {
          this.$alert.show(data.description, {
            title: data.title,
            confirmCallBack: () => {
              gioAdsTracking({
                "adsType": "pp"
              })
            }
          });
          return;
        }

        const isPopuped = Cookies.get("rcclinformModal", { path: "/" });
        if (isPopuped && isPopuped.length > 0) {
          return;
        }
        this.$alert.show(data.description, {
          title: data.title,
					confirmCallBack: () => {
						gioAdsTracking({
							"adsType": "pp"
						})
					}
        });
        Cookies.set("rcclinformModal", data.id, { expires: 1 });
      }
    },
  },
};
</script>

<style lang="less" scoped>
</style>